// extracted by mini-css-extract-plugin
export default {"socialsBlock":"socialsBlock__uTqQ8"};